import React from "react"

const OrganisationOnboardingContext = React.createContext({})

const { Provider, Consumer } = OrganisationOnboardingContext

export { Provider, Consumer, OrganisationOnboardingContext }
